module.exports = __webpack_public_path__ + "img/video-blog.e3146951.svg";